module.exports = __webpack_public_path__ + "f94bc3ef0f8fb8bcd352adb6451ed26c.svg";